import { gql } from '@apollo/client'

export const DeclineInvite = gql`
    mutation DeclineInvite($id: ID!) {
        declineInvite(id: $id) {
            id
            created
            email
            invites {
                id
                issuer {
                    id
                    username
                }
                room {
                    id
                    name
                    owner {
                        id
                        username
                    }
                }
            }
            rooms {
                id
                name
                topic
                spinning
                owner {
                    id
                    username
                }
                admins {
                    id
                    username
                }
                members {
                    id
                    username
                }
            }
            roles
            updated
            username
        }
    }
`

export default DeclineInvite
